import { FC } from 'react';

import { AuthenticatedBanners } from './AuthenticatedBanners';
import { PausedDeliveryBanner } from './PausedDeliveryBanner';
import { SetupIncompleteBanner } from './SetupIncompleteBanner';

export const GlobalAuthenticatedBanners: FC = () => {
  return (
    <>
      <SetupIncompleteBanner />
      <PausedDeliveryBanner />
      <AuthenticatedBanners />
    </>
  );
};
